export default __webpack_public_path__ + "static/media/undraw_mobile_apps_re_3wjf.c1206cfc.svg";